import { render, staticRenderFns } from "./tdpcontactrpt.vue?vue&type=template&id=65054836"
import script from "./tdpcontactrpt.vue?vue&type=script&lang=js"
export * from "./tdpcontactrpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports